import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../loader/loader';
import NotAuthorized from '../notAuthorized/notAuthorized';
import { validateToken } from '../../API/server/validateToken';
import getCondominioData from '../../API/server/getCondominios';

const PrivateRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('user')) {
      setIsAuthorized(true);
      setIsLoading(false);
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const user = queryParams.get('user');
    const condominio = queryParams.get('condominio');
    const token = queryParams.get('token');

    console.log('Parâmetros recebidos:', { user, condominio, token });

    if (!user || !condominio || !token) {
      console.warn('Parâmetros ausentes ou inválidos!');
      setIsAuthorized(false);
      setIsLoading(false);
      return;
    }

    // Valida o token e, em seguida, coleta os dados do condomínio
    validateToken({ token, user, condominio })
      .then(async () => {
        const condominioData = await getCondominioData();
        // Remove a propriedade "message" antes de armazenar
        const { message, ...dataWithoutMessage } = condominioData;
        sessionStorage.setItem("condominioInfo", JSON.stringify(dataWithoutMessage));
        setIsAuthorized(true);
        // Remove os parâmetros da URL
        const newUrl = location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      })
      .catch((error) => {
        console.error('Erro na validação do token:', error);
        setIsAuthorized(false);
        navigate('/');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [location.search, location.pathname, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  return isAuthorized ? children : <NotAuthorized />;
};

export default PrivateRoute;
